// extracted by mini-css-extract-plugin
export var container = "_4m-0";
export var fallback = "_4m-5";
export var fallbackIcon = "_4m-6";
export var hidden = "_4m-2";
export var image = "_4m-3";
export var loaded = "_4m-4";
export var placeholder = "_4m-1";